import { Button, Flex } from "antd";
import { useState } from "react";

type TProps = {
  data: [string, string][];
};

export default function ExtractLocaleItems({ data }: TProps) {
  const [activeItem, setActiveItem] = useState<string | null>(
    data?.[0]?.[0] || null
  );

  const handleItemClick = (key: string) => {
    setActiveItem(key);
  };

  const searchedItem = data.find(([key]) => key === activeItem);

  return (
    <Flex vertical gap={4}>
      <Flex gap={32}>
        {data.map(([key]) => (
          <Button
            type="text"
            key={key}
            onClick={() => handleItemClick(key)}
            style={{
              cursor: "pointer",
              padding: "0 2px",
              maxHeight: "20px",
              color: "#555",
            }}
          >
            <i
              style={{
                textDecoration: activeItem === key ? "underline" : "none",
              }}
            >
              {key}
            </i>
          </Button>
        ))}
      </Flex>

      {searchedItem?.[1] && <div>"{searchedItem?.[1]}"</div>}
    </Flex>
  );
}
